export default "__VITE_ASSET__DDsAy4jU__"